import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Estimate from "./sections/Estimate";
import ServiceAreas from "./sections/ServiceAreas";
import PlanningGuide from "./sections/PlanningGuide";
import Privacy from "./sections/Privacy";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Hero />
      <Estimate />
      <ServiceAreas />
      <PlanningGuide />
      <Privacy />
      <Terms />
      <Footer />
    </div>;
}